import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";

import { CheckToken } from "../login/AccessToken";
import "./Patient.scss";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import SideNavbar from "./SideNavbar";
import NoDataPage from "./NoDataPage";
import { Grid, Button } from "@mui/material";

import SaveAlt from "@mui/icons-material/SaveAlt";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";

const Patient = () => {
  const [showColumns, setShowColumns] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const [patientList, setPatientList] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedRows, setSelectedRows] = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const history = useHistory();

  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);

  const Token = () => {
    const check = CheckToken();
    console.log(check);
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  useEffect(() => {
    if (authToken !== "") {
      axios
        .get(
          `${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`,
          {
            headers: headers,
          }
        )
        .then((res) => {
          const patientsWithId = res.data?.data.map((patient, index) => ({
            ...patient,
            id: index + 1,
          }));
          setPatientList(patientsWithId);
        });
    }
  }, [authToken]);

  const getRowClassName = (params) => {
    return "custom-row";
  };
  const totalPages = Math.ceil(serviceList.length / rowsPerPage);

  const columns = [
    { field: "name", headerName: "Name", width: 220 },
    { field: "gender", headerName: "Gender", width: 200 },
    { field: "email", headerName: "Email", width: 180 },
    { field: "age", headerName: "Age", width: 150 },
    { field: "dob", headerName: "Date of Birth", width: 200 },
    { field: "phone_no", headerName: "Phone Number", width: 180 },
  ];

  const generatePdf = () => {
    const doc = new jsPDF();
    doc.autoTable({
      head: [["Name", "Gender", "Email", "Age", "Date of Birth", "Phone Number"]],
      body: patientList.map((p) => [
        p.name,
        p.gender,
        p.email,
        p.age,
        p.dob,
        p.phone_no,
      ]),
    });
    doc.save("patients.pdf");
  };

  const generateCsvData = () => {
    return patientList.map((patient) => ({
      Name: patient.name,
      Gender: patient.gender,
      Email: patient.email,
      Age: patient.age,
      "Date of Birth": patient.dob,
      "Phone Number": patient.phone_no,
    }));
  };

  return (
    <>
      <SideNavbar />

      <div className="patient-wrapper">
        <p className="page-title">Patient records</p>
        <div className="display-flex">
          {patientList !== undefined && patientList.length > 0 ? (
            <DataGrid
              rows={patientList}
              columns={columns}
              components={{
                Toolbar: () => (
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{
                      mb: 2,
                    }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={8}
                      sx={{ display: "flex", gap: 1 }}
                    >
                      <GridToolbarColumnsButton />
                      <GridToolbarFilterButton />
                      <GridToolbarDensitySelector />
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      sx={{
                        display: "flex",
                        gap: 1,
                        justifyContent: { xs: "center", sm: "flex-end" },
                      }}
                    >
                      <Button
                        variant="text"
                        color="primary"
                        onClick={() => generatePdf()}
                        startIcon={<SaveAlt />}
                      >
                        Download PDF
                      </Button>
                      <CSVLink
                        data={generateCsvData()}
                        filename={"patient_records.csv"}
                        target="_blank"
                      >
                        <Button
                          variant="text"
                          color="primary"
                          startIcon={<SaveAlt />}
                        >
                          Download CSV
                        </Button>
                      </CSVLink>
                    </Grid>
                  </Grid>
                ),
              }}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 10 },
                },
              }}
              pageSizeOptions={[5, 10]}
              getRowClassName={getRowClassName}
              sx={{
                "& .MuiDataGrid-root": {
                  border: "1px solid #e0e0e0",
                  borderRadius: "4px",
                  fontFamily: "Arial, sans-serif",
                  padding:"5px"
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#125386",
                  color: "white",
                  fontSize: "13px",
                  fontWeight: "600",
                  minHeight: "48px !important",
                  "& .MuiDataGrid-columnHeaderTitle": {
                    color: "white",
                    fontWeight: "600",
                    fontSize: "13px",
                  },
                  "& .MuiDataGrid-columnHeader": {
                    borderRight: "1px solid rgba(255, 255, 255, 0.3)",
                    padding: "0 12px",
                  },
                  "& .MuiDataGrid-columnHeader:last-child": {
                    borderRight: "none",
                  },
                  "& .MuiDataGrid-iconButtonContainer": {
                    color: "white",
                  },
                  "& .MuiDataGrid-menuIcon": {
                    color: "white",
                  },
                  "& .MuiDataGrid-sortIcon": {
                    color: "white",
                  },
                  "& .MuiDataGrid-columnHeaderSortable": {
                    "& .MuiDataGrid-sortIcon": {
                      color: "white",
                    },
                  },
                  "& .MuiDataGrid-columnHeaderTitleContainer": {
                    "& .MuiDataGrid-sortIcon": {
                      color: "white",
                    },
                  },
                  "& .MuiSvgIcon-root": {
                    color: "white",
                  },
                },
                "& .MuiDataGrid-row": {
                  backgroundColor: "white",
                  minHeight: "40px !important",
                  "&:nth-of-type(even)": {
                    backgroundColor: "white",
                  },
                  "&:hover": {
                    backgroundColor: "#f8f9fa",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "#e3f2fd",
                    "&:hover": {
                      backgroundColor: "#e3f2fd",
                    },
                  },
                  borderBottom: "1px solid #e0e0e0",
                },
                "& .MuiDataGrid-cell": {
                  borderRight: "1px solid #e0e0e0",
                  fontSize: "12px",
                  color: "#374151",
                  padding: "8px 12px",
                  minHeight: "40px !important",
                  "&:last-child": {
                    borderRight: "none",
                  },
                  "&:focus": {
                    outline: "none",
                  },
                },
                "& .MuiDataGrid-cellContent": {
                  fontSize: "12px",
                  color: "#374151",
                  fontWeight: "400",
                },
                "& .MuiDataGrid-footerContainer": {
                  backgroundColor: "#f8f9fa",
                  borderTop: "1px solid #e0e0e0",
                  minHeight: "52px",
                },
                "& .MuiTablePagination-root": {
                  color: "#374151",
                  fontSize: "12px",
                },
                "& .MuiDataGrid-toolbarContainer": {
                  backgroundColor: "#f8f9fa",
                  borderBottom: "1px solid #e0e0e0",
                  padding: "8px 16px",
                },
              }}
            />
          ) : (
            <NoDataPage />
          )}
        </div>
      </div>
    </>
  );
};

export default Patient;